<template>
  <div id="signin-container" class="authportal-container">
    <div class="authportal-header text-uppercase" id="signin-header">sign in</div>
    <v-sheet tile elevation="4" class="authportal-form-wrapper">
      <transition name="fade">
        <div class="authportal-error-container" v-if="hasError">
          <div class="icon-sprite authportal-error-icon"></div>
          <div class="authportal-error-message">{{ signInErrorMessage }}</div>
        </div>
         <div class="authportal-succeed-container" v-if="hasSucceed">
          <div class="icon-correct authportal-succeed-icon"></div>
          <div class="authportal-succeed-message">{{ signInSucceedMessage }}</div>
        </div>
      </transition>
      <div
        class="authportal-form-subheader"
      >Please enter your email and password to access your account</div>
      <v-form ref="signInForm" v-model="isValid" lazy-validation class="mt-6">
        <div class="authportal-form-field mt-3">
          <div class="authportal-form-field-label d-flex align-self-center">email*</div>
          <div class="authportal-form-field-input d-flex">
            <div class="authportal-form-input">
              <v-text-field
                v-model="email"
                ref="username"
                filled
                solo
                flat
                required
                type="text"
                :rules="signInUsernameRule"
                hide-details
              ></v-text-field>
            </div>
            <div
              class="authportal-form-field-input-error-msg"
              v-if="isMounted"
            >{{ inputFieldErrorMsg("username") }}</div>
          </div>
        </div>
        <div class="authportal-form-field mt-3">
          <div class="authportal-form-field-label d-flex align-self-center">password*</div>
          <div class="authportal-form-field-input d-flex">
            <div class="authportal-form-input">
              <v-text-field
                v-model="password"
                ref="password"
                filled
                solo
                flat
                required
                type="password"
                :rules="signInPasswordRule"
                v-on:keyup.enter="performSignIn"
                hide-details
              ></v-text-field>
            </div>
            <div
              class="authportal-form-field-input-error-msg"
              v-if="isMounted"
            >{{ inputFieldErrorMsg("password") }}</div>
          </div>
        </div>
        <div
          id="authportal-forgot-password"
          class="font-size-12 font-italic authportal-hack-width d-flex justify-end mt-2"
        >
          <router-link to="/ap/forgotPassword">
            <span class="pb-1">Forgot your password ?</span>
          </router-link>
        </div>
        <div class="authportal-hack-width d-flex justify-end">
          <v-btn
            color="#e2211c"
            outlined
            tile
            width="270px"
            class="mt-9"
            @click="performSignIn"
            :loading="performSignInPending"
          >log in ></v-btn>
        </div>
        <div
          id="authporta-create-account"
          class="authportal-account-condition-hint authportal-hack-width d-flex justify-end font-size-12 mt-5"
        >
          Don't have an account ?
          <router-link to="/ap/signup">
            <span class="pb-1 ml-2">Sign Up Now!</span>
          </router-link>
        </div>
      </v-form>
    </v-sheet>
  </div>
</template>

<script>
import authPortalSignInMixins from "../../../mixins/authPortalSignInMixins";
import authPortalMixins from "../../../mixins/authPortalMixins";

export default {
  mixins: [authPortalMixins, authPortalSignInMixins]
};
</script>

<style scoped>
@import "../../../styles/authportalCommon.css";

#signin-container.authportal-container {
  background: linear-gradient(90deg, transparent 50%, #e2211c 50%);
}

#signin-header {
  left: 51%;
}

#authportal-forgot-password span {
  color: #999999;
  border-bottom: 1px solid #999999;
}

</style>